<template>
  <div>
    <el-dialog title='发送邮件' :visible.sync='updateDialogSendmail' width='30%' @close='updateClose'>
      <el-form label-width='100px'>
        <div class='label'>
          <el-form-item label='邮箱'>
            <el-input v-model='sendmailFrom.tos'></el-input>
          </el-form-item>
        </div>


        <el-form-item label='标题'>
          <el-input v-model='sendmailFrom.subject'></el-input>
        </el-form-item>

        <el-form-item label='内容'>
          <el-input v-model='sendmailFrom.content'></el-input>
        </el-form-item>

        <el-form-item label='上传文件'>
          <input ref='files' @change='update' type='file' hidden />
          <el-button class='btn' size='small' @click='openFile'>点击上传</el-button>
          <span v-if='files' style='padding-left: 10px;'>已上传</span>
          <span v-else style='padding-left: 10px;'>未上传</span>
        </el-form-item>
      </el-form>
      <span slot='footer' class='dialog-footer'>
        <el-button @click='updateDialogSendmail = false'>取 消</el-button>
        <el-button type='primary' @click='updateSendmail'>确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>

import { updateEnclosure } from '@/api/rule/rule'
import { sendRaceMail } from '@/api/race/race'

export default {
  name: 'sendmail',
  data() {
    return {
      updateDialogSendmail: false,
      sendmailFrom: {
        tos: '',
        subject: '',
        content: ''
      },
      files: '',
      formData: ''
    }
  },
  methods: {
    editDialog(data) {
      this.sendmailFrom.tos = JSON.parse(JSON.stringify(data.email))
      this.sendmailFrom.raceId = data.id
      this.updateDialogSendmail = true
    },

    updateClose() {
      this.sendmailFrom = {
        tos: '',
        subject: '',
        content: ''
      }
    },

    updateSendmail() {
      if (!this.sendmailFrom.tos || !this.files) {
        this.$message.error('请完善邮箱或文件')
      } else {
        this.formData = new FormData()
        this.formData.append('file', this.files)
        sendRaceMail(this.formData, this.sendmailFrom).then(res => {
          if (res.code === '0') {
            this.$message({
              message: '发送成功',
              type: 'success'
            })
            this.$emit('refresh-list')
            this.updateDialogSendmail = false
          } else {
            this.$message.error('发送失败')
          }
        })

      }

    },

    openFile() {
      this.$refs.files.click()
    },

    update() {
      this.files = this.$refs.files.files[0]
    }
  }
}
</script>

<style scoped>

</style>
